import FlashLib from "flashlib";

export default class SymbolsPool {
    static get pool() {
        if(!this._pool) {
            this._pool = [];
        }
        return this._pool;
    }

    static poolIn(item) {
        let inItem = item;
        if(inItem === undefined) {
            inItem = FlashLib.createItemFromLibrary('Symbol', 'GameFlashLib');
        }
        if(inItem.parent) {
            inItem.parent.removeChild(inItem);
        }
        this.pool.push(inItem);
    }

    static poolOut(id) {
        if(this.pool.length === 0) {
            this.poolIn()
        }
        let symbol = this.pool.shift();
        symbol.changeSymbol(id);
        return symbol;
    }
}